module.exports = "/_next/static/images/1880d7928430dbabc00af77e05957439-steps-desktop.jpg";